import { render, staticRenderFns } from "./RoundEdit.vue?vue&type=template&id=baebdb8c"
import script from "./RoundEdit.vue?vue&type=script&lang=js"
export * from "./RoundEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports